import { timezones } from '@occc-app/lib/constants';

import { TimezoneAutocompleteFormValues, Timezone } from './types';

export const getTimezoneAutocompleteInitialValues = (
  timezoneName: string,
): TimezoneAutocompleteFormValues => {
  return (
    timezones.find((tz) => tz.name === timezoneName) || {
      name: timezoneName,
    }
  );
};

export const useTimezonesQuery = () => {
  return {
    executeQuery: () => null,
    response: timezones,
  };
};
export const mapQueryResponseToRawArray = (response: Timezone[]) => response;
export const mapRawTimezoneResponseItemToAutocompleteOption = (item: Timezone) => ({
  value: item.name,
  label: item.name,
  _raw: item,
});
